<template>
  <v-container fluid class="px-0">
    <el-overlay-loading :loading="pageloading" />
    <!-- title  -->
    <h1 class="mb-1">{{ $t('Juridiniai asmenys be OBJ_ID') }}</h1>
    <jar-failed-obj-id-search :loading="loading" @search="doSearch" />

    <!-- table -->
    <v-data-table
      class="mb-4 custom-table sticky-header"
      :loading="loading || paginationloading"
      :headers="filteredHeader"
      :items="filterItemList"
      :hide-default-footer="hideFooter"
      :header-props="{
        sortByText: $t('Rūšiuoti pagal')
      }"
      :footer-props="{
        showFirstLastPage: true,
        showCurrentPage: true,
        itemsPerPageText: $t('Rodyti po:'),
        itemsPerPageAllText: $t('visi'),
        itemsPerPageOptions: itemsPerPageOptions,
      }"
      :sort-by.sync="pagination.sort"
      :sort-desc.sync="pagination.sortDesc"
      :server-items-length="pagination.total"
      :items-per-page="pagination.pageSize"
      :page.sync="pagination.page"
      @update:options="updatePagination"
    >
      <!-- custom templates -->
      <template #[`item.actions`]="{ item }">
        <div class="nowrap">
          <el-table-action
            :item="setIcons(item)"
            @retryItem="confirmInModaltem(item)"
            @viewInModaltem="viewInModaltem(item)"
          />
        </div>
      </template>
      <!-- basic templates -->
      <template slot="loading"> {{ $t('Kraunasi...') }} </template>
      <template slot="no-results"> {{ $t('Duomenų nėra') }} </template>
      <template slot="no-data"> {{ $t('Duomenų nėra') }} </template>
      <template #[`footer.page-text`]="props">
        {{ $t('Rodoma') }} {{ props.pageStart }}-{{ props.pageStop }} {{ $t('iš') }}
        {{ props.itemsLength }}
      </template>
    </v-data-table>

    <modal-jar-obj-id-missing
      v-model="showModal"
      info
      :loading="loading"
      :item="selectedItem"
      width="600px"
    />
    <modal-confirm
      :title="confirmModalTitle"
      :text="confirmModalText"
      v-model="showConfirmModal"
      @confirmData="retryItem"
      @closeConfirmModal="clearSelectedItem"
      :loading="loading"
      width="600px"
      />
  </v-container>
</template>


<script>
import userRole from '@/mixins/userRole'
import { mapGetters } from 'vuex'
import math from '@/mixins/math'
import ModalJarObjIdMissing from '@/components/modals/ModalJarObjIdMissing'
import ModalConfirm from '@/components/modals/ModalConfirm'
import JarFailedObjIdSearch from './JarFailedObjIdSearch.vue'

export default {
  name: 'JarFailedJobs',
  components: {
    ModalConfirm,
    ModalJarObjIdMissing,
    JarFailedObjIdSearch
  },
  mixins: [userRole, math],
  data() {
    return {
      pageloading: false,
      loading: false,
      paginationloading: false,
      search: null,
      listData: [],
      searchData: {},
      itemsPerPageOptions: [10, 50, 100],
      pagination: {
        page: 1,
        pageSize: 100,
        total: 0,
        totalPages: 0,
        sort: null,
        sortDesc: [],
        direction: 'asc',
      },

      showModal: false,
      selectedItem: null,

      showConfirmModal: false,
      confirmModalTitle: "",
      confirmModalText: "",
    }
  },
  computed: {
    ...mapGetters(['listParams']),
    headers() {
      return [
        {
          text: this.$t('Veiksmai'),
          align: 'center',
          sortable: false,
          value: 'actions',
        },
        {
          text: this.$t('AMN_ID'),
          align: 'start',
          value: 'amn_id',
        },
        {
          text: this.$t('Juridinio asmens kodas'),
          align: 'start',
          value: 'code',
        },
        {
          text: this.$t('Pavadinimas'),
          align: 'start',
          value: 'fullname',
        },
        {
          text: this.$t('Užklausos į JAR data'),
          align: 'start',
          value: 'jar_request_date',
        },
      ]
    },

    filteredHeader() {
      return this.headers.filter((item) => {
        return !item.hide
      })
    },

    filterItemList() {
      return this.listData.map((item) => {
        return item
      })
    },

    hideFooter() {
      return this.pagination.total <= 10
    },
  },
  created() {
    this.setlistParams()
  },
  methods: {
    setIcons(item) {
      item.canViewInModal = true
      item.canRetry = true
      return item
    },
    clearSelectedItem() {
      this.selectedItem = null
    },
    retryItem() {
        this.loading = true
        this.pageloading = true
        this.paginationloading = true
        this.$axios.post(`persons/${this.selectedItem.id}/clearJarData`)
        .then((res) => {
          this.$root.$emit('DATA_OK', res.data.message)
          this.getData()
        })
        .catch((err) => {
          this.$root.$emit('DATA_ERROR', err)
        })
        .finally(() => {
          this.loading = false
          this.pageloading = false
          this.paginationloading = false
          this.selectedItem = null
          this.showConfirmModal = false
        })
    },
    setlistParams(){
      if (this.listParams && (this.pagination.pageSize != this.listParams.pageSize) && (this.listParams.pageSize != null)) {
        this.pagination.pageSize = this.listParams.pageSize
      } 
    },
    getData(resetPageNr = false) {
      if (resetPageNr) {
        this.pagination.page = 1
      }

      const data = {
        ...this.pagination,
        search: this.searchData,
      }

      this.$axios
        .post(`persons/missingObjId/list`, data)
        .then((res) => {
          this.listData = res.data.persons
          this.pagination = { ...this.pagination, ...res.data.pagination }
        })
        .catch((err) => {
          this.$root.$emit('DATA_ERROR', err)
        })
        .finally(() => {
          this.loading = false
          this.pageloading = false
          this.paginationloading = false
        })
    },
    viewInModaltem(item){
      this.selectedItem = item
      this.showModal = true
    },
    confirmInModaltem(item){
      this.selectedItem = item;
      this.showConfirmModal = true
      this.confirmModalTitle = item.code
      this.confirmModalText = "Ar tikrai norite pakartotinai atlikti užduotį?"
    },
    updatePagination(pagination) {
      if (this.paginationloading) {
        return
      }
      this.$store.dispatch('listParams', {
          pageSize: pagination.itemsPerPage,
      })
      this.paginationloading = true
      this.pagination.page = pagination.page
      this.pagination.pageSize = pagination.itemsPerPage
      this.pagination.sort = pagination.sortBy[0]
      this.pagination.sortDesc = pagination.sortDesc
      this.pagination.direction = pagination.sortDesc[0] ? 'desc' : 'asc'

      if (!this.loading) {
        this.getData()
      }
    },
    doSearch(searchData) {
      this.searchData = searchData
      this.loading = true
      this.getData(true)
    },
  },
}
</script>
